import { useMemo } from "react";
import { EXPERIENCE_STATES } from "constants/experiences";
import { useDebounce } from "hooks/useDebounce";

export const useTripSearchLogic = ({
  trips,
  searchQuery,
  selectedTrip,
}) => {

  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const categorizedTrips = useMemo(() => ({
    publishedTrips: trips.filter(t => t.status === EXPERIENCE_STATES.published),
    drafts: trips.filter(t => t.status === EXPERIENCE_STATES.draft),
    deactivatedTrips: trips.filter(t => t.status === EXPERIENCE_STATES.deactivated)
  }), [trips]);
  
  const categorizedSearchResults = useMemo(() => {
    const q = debouncedSearchQuery.trim().toLowerCase();
    if (!q) return { publishedTrips: [], drafts: [], deactivatedTrips: [] };
    return {
      publishedTrips: categorizedTrips.publishedTrips.filter(t => t.title.toLowerCase().includes(q)),
      drafts: categorizedTrips.drafts.filter(t => t.title.toLowerCase().includes(q)),
      deactivatedTrips: categorizedTrips.deactivatedTrips.filter(t => t.title.toLowerCase().includes(q)),
    };
  }, [debouncedSearchQuery, categorizedTrips]);

  const filteredTrips = useMemo(() => {
    if (selectedTrip) {
      return {
        publishedTrips: selectedTrip.status === EXPERIENCE_STATES.published ? [selectedTrip] : [],
        drafts: selectedTrip.status === EXPERIENCE_STATES.draft ? [selectedTrip] : [],
        deactivatedTrips: selectedTrip.status === EXPERIENCE_STATES.deactivated ? [selectedTrip] : [],
      };
    }
    if (debouncedSearchQuery.trim()) return categorizedSearchResults;
    return categorizedTrips;
  }, [selectedTrip, debouncedSearchQuery, categorizedSearchResults, categorizedTrips]);

  return {
    debouncedSearchQuery,
    categorizedTrips,
    categorizedSearchResults,
    filteredTrips
  };
}; 